import axios from "axios";
import { mapProduct } from "~/modules/catalog/category/helpers/mapProduct";
import { ParamElasticSearch } from "./types";
import { ref } from "@nuxtjs/composition-api";

export function useSearchProducts() {
  const vueUrl = process.env.VUE_URL;
  const storeId = 2;
  const loading = ref(false);

  const aggsConfig =
    ',"aggs":{"agg_terms_color":{"terms":{"field":"color","size":10}},' +
    '"agg_terms_color_options":{"terms":{"field":"color_options","size":10}},' +
    '"agg_terms_price":{"terms":{"field":"final_price","size":100}},' +
    '"agg_terms_size":{"terms":{"field":"size","size":10}},' +
    '"agg_terms_size_options":{"terms":{"field":"size_options","size":100}},' +
    '"agg_terms_onoff_materials":{"terms":{"field":"onoff_materials","size":10}},' +
    '"agg_terms_type_product":{"terms":{"field":"type_product","size":10}},' +
    '"agg_terms_style_type":{"terms":{"field":"style_type","size":10}},' +
    '"agg_terms_style_type_options":{"terms":{"field":"style_type_options","size":10}},' +
    '"agg_terms_sizeguide":{"terms":{"field":"sizeguide","size":10}},' +
    '"agg_terms_mastercolor":{"terms":{"field":"mastercolor","size":100}},' +
    '"agg_terms_mastercolor_options":{"terms":{"field":"mastercolor_options","size":100}}}';

  const fetchProducts = async (params: ParamElasticSearch = {}) => {
    const { search = "", ids = [], skus = [], aggs = false, pageSize = 1, currentPage = 1, filters = {}, loadHidden = false, urlKey = "" } = params;

    try {
      loading.value = true;
      let from = pageSize * (currentPage - 1);
      let actualPageSize = pageSize;

      let categoryQuery = "";
      let sortQuery = "";
      let positionQuery = "";

      if (ids.length) {
        const strCategoryId = ids.join(",");
        categoryQuery = `,{"terms":{"category_ids":[${strCategoryId}]}}`;
        const mainCategoryId = ids[0];
        sortQuery = "";
        positionQuery = `,"sort":[{"category.position":{"order":"asc","mode":"min","nested_path":"category","nested_filter":{"term":{"category.category_id":${mainCategoryId}}}}}]`;
      }

      // priceRanger, sizeId, colorId,
      //{"bool":{"should":[{"terms":{"size":["7"]}},{"bool":{"must":[{"terms":{"size_options":["7"]}}
      // {"bool":{"should":[{"terms":{"color":["67"]}},{"bool":{"must":[{"terms":{"color_options":["67"]}}
      // {"bool":{"should":[{"range":{"final_price":{"gte":50,"lte":100}}},{"bool":{"must":[{"range":{"final_price":{"gte":50,"lte":100}}}
      //   let filters = {priceRanger: priceRanger, sizeSelected: sizeSelected, colorSelected: colorSelected}
      let filterQuery = "";
      if (filters?.priceRanger) {
        filterQuery += `,{"bool":{"should":[{"range":{"final_price":{"gte":${filters.priceRanger[0]},"lte":${filters.priceRanger[1]}}}},{"bool":{"must":[{"range":{"final_price":{"gte":${filters.priceRanger[0]},"lte":${filters.priceRanger[1]}}}}]}}]}}`;
      }

      if (filters?.groupPriceRanger) {
        // Có 2 cách để tạo filter theo group price ranger
        // let arrText = filters?.groupPriceRanger.map(
        //   pr => `{"range":{"final_price":{"gte":${pr[0]},"lte":${pr[1]}}}}`,
        // );

        let arrText = filters?.groupPriceRanger.map((pr) => `{"bool":{"must":[{"range":{"final_price":{"gte":${pr[0]},"lte":${pr[1]}}}}]}}`);

        let shouldText = arrText.join(", ");
        filterQuery += `,{"bool":{"should":[${shouldText}]}}`;
      }

      if (filters?.sizeIds?.length) {
        let sizeIds = filters.sizeIds.join('","');
        filterQuery += `,{"bool":{"should":[{"terms":{"size":["${sizeIds}"]}},{"bool":{"must":[{"terms":{"size_options":["${sizeIds}"]}}]}}]}}`;

        let stringQtySize = filters.sizeIds.join('_1","');
        stringQtySize += "_1";

        filterQuery += `,{"bool":{"must":[{"terms":{"configurable_children.logistic_qty_size":["${stringQtySize}"]}}]}}`;
      }

      if (filters?.colorIds?.length) {
        let colorIds = filters.colorIds.join('","');
        filterQuery += `,{"bool":{"should":[{"terms":{"mastercolor":["${colorIds}"]}},{"bool":{"must":[{"terms":{"configurable_children.mastercolor":["${colorIds}"]}}]}}]}}`;

        let stringQtyColor = filters.colorIds.join('_1","');
        stringQtyColor += "_1";

        filterQuery += `,{"bool":{"must":[{"terms":{"configurable_children.logistic_qty_mastercolor":["${stringQtyColor}"]}}]}}`;
      }

      if (filters?.sizeGuideIds?.length) {
        let sizeGuideIds = filters.sizeGuideIds.join('","');
        filterQuery += `,{"bool":{"should":[{"terms":{"sizeguide":["${sizeGuideIds}"]}},{"bool":{"must":[{"terms":{"sizeguide_options":["${sizeGuideIds}"]}}]}}]}}`;
      }

      if (filters?.typeIds?.length) {
        let typeIds = filters.typeIds.join('","');
        filterQuery += `,{"bool":{"should":[{"terms":{"type_product":["${typeIds}"]}},{"bool":{"must":[{"terms":{"type_product_options":["${typeIds}"]}}]}}]}}`;
      }

      if (filters?.materialIds?.length) {
        let materialIds = filters.materialIds.join('","');
        filterQuery += `,{"bool":{"should":[{"terms":{"onoff_materials":["${materialIds}"]}},{"bool":{"must":[{"terms":{"onoff_materials_options":["${materialIds}"]}}]}}]}}`;
      }

      if (filters?.tag) {
        filterQuery += `,{"bool":{"must":{"multi_match":{"query":"${filters.tag}","fields":["tag"],"type": "phrase"}}}}`;
      }

      if (filters?.order && filters?.orderby) {
        sortQuery = `${filters.orderby}:${filters.order}`;
        positionQuery = "";
      }

      let skuQuery = "";
      if (skus.length) {
        let skuForQuery = skus.map((sku) => `"${encodeURIComponent(sku)}"`);
        from = 0;
        actualPageSize = 1000;
        // skuQuery = `,{"terms":{"sku":[${skuForQuery}]}}`;
        skuQuery = `,{"bool":{"should":[{"terms":{"sku":[${skuForQuery}]}},{"bool":{"must":[{"terms":{"configurable_children.sku":[${skuForQuery}]}}]}}]}}`;
      }

      let urlKeyQuery = "";
      if (urlKey !== "") {
        urlKeyQuery = `,{"terms":{"url_path":["${urlKey}"]}},{"terms":{"url_key":["${urlKey}"]}},{"terms":{"slug":["${urlKey}"]}}`;
      }

      let visibility = search !== "" ? "3,4" : loadHidden ? "1,2,3,4" : "2,3,4";
      // let visibility = "2,3,4";

      let aggsQuery = aggs ? aggsConfig : "";

      let searchQuery = "";
      if (search !== "") {
        searchQuery = `"must":{"multi_match":{"query":"${search}","fields":["meta_keyword","sku","name","description","meta_description","image"],"type": "phrase"}},`;
        positionQuery = "";
        sortQuery = sortQuery == "" ? "created_at:desc" : sortQuery;
      }
      const request = `{"query":{"bool":{${searchQuery}"filter":{"bool":{"must":[{"terms":{"visibility":[${visibility}]}},{"terms":{"status":[0,1]}}${categoryQuery}${filterQuery}${skuQuery}${urlKeyQuery}]}}}}${aggsQuery},"groupToken":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJncm91cF9pZCI6MSwiaWQiOjMsInVzZXIiOiJ2YW5kQGdtYWlsLmNvbSJ9.VMNebCbNSLF8xlyoG4qcaWlP21OFgcXJR3Ak2C0Oyac"${positionQuery}}`;

      let url = vueUrl + "/search_product";
      let indexName = `vue_storefront_catalog_${storeId}`;
      let query = JSON.parse(request);
      let queryParams = {
        from: from,
        size: actualPageSize,
        sort: sortQuery,
      };

      let params = {
        indexName,
        query,
        queryParams,
      };

      let response = await axios.post(url, params);
      let hits = response?.data?.hits || {};

      let items = [];
      let total = hits?.total?.value || 0;
      let aggregations = response?.data?.aggregations || [];

      let products = hits?.hits || [];
      if (products.length) {
        products.forEach((value) => {
          let item = value._source;
          const product = mapProduct(item);
          items.push(product);
        });
      }
      loading.value = false;
      return { data: items, total: total, aggregations: aggregations };
    } catch (e) {
      console.error("fetchProducts e.message==== ", e.message);
      return { data: [], total: 0, aggregations: [] };
    } finally {
      loading.value = false;
    }
  };
  return {
    fetchProducts,
    loading,
  };
}

export default useSearchProducts;
